import { render, staticRenderFns } from "./MiniProgramReleaseManage.vue?vue&type=template&id=74c93fc6"
import script from "./MiniProgramReleaseManage.vue?vue&type=script&lang=js"
export * from "./MiniProgramReleaseManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74c93fc6')) {
      api.createRecord('74c93fc6', component.options)
    } else {
      api.reload('74c93fc6', component.options)
    }
    module.hot.accept("./MiniProgramReleaseManage.vue?vue&type=template&id=74c93fc6", function () {
      api.rerender('74c93fc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wechatOpenPlatform/components/MiniProgramReleaseManage.vue"
export default component.exports